<template>
  <div v-if="applicantSkillCategories">
    <div class="custom-accordion">
      <div
        v-for="item in applicantSkillCategories.results"
        :key="item.sort"
        class="custom-accordion--item"
        :class="{
          'is-active': item.id === selected,
          loaded: loadedSkills.indexOf(item.id) !== -1
        }"
      >
        <button
          class="custom-accordion--header"
          @click="e => openSkillCategory(e, item.id)"
        >
          {{ item.name }} <i class="far fa-chevron-down"></i>
        </button>
        <div class="accordion-content">
          <Skill
            v-if="loadedSkills.indexOf(item.id) !== -1 || item.id == selected"
            v-model="item.id"
            :group="value"
            :profile-id="profileId"
            @loaded="loadedSkills.push(item.id)"
          />

          <DataInput
            :value="getCustomValue(item.id)"
            name="customValue"
            @input="e => updateCustomValue(item.id, e)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import Skill from "./Skill.vue";
import DataInput from "@/components/ui/DataInput";

export default {
  components: {
    DataInput,
    Skill
  },
  props: {
    profileId: { type: String, required: true },
    value: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      customValueTimeouts: {},
      selected: "",
      loadedSkills: []
    };
  },
  apollo: {
    applicantProfileSkillCategoryValues: {
      query: gql`
        query($profile: ID!) {
          applicantProfileSkillCategoryValues(profile: $profile) {
            profile {
              id
            }
            skillCategory {
              id
            }
            value
          }
        }
      `,
      skip() {
        return !this.profileId;
      },
      variables() {
        return {
          profile: this.profileId
        };
      }
    },
    applicantSkillCategories: {
      query: gql`
        query($groupId: ID!) {
          applicantSkillCategories(group: $groupId, page: 1) {
            results {
              id
              name
            }
          }
        }
      `,
      variables() {
        return {
          groupId: this.value
        };
      }
    }
  },
  methods: {
    openSkillCategory(e, id) {
      document.querySelectorAll(".accordion-content").forEach(el => {
        el.style.maxHeight = "0px";
      });

      this.selected = id === this.selected ? null : id;
      if (!this.selected) {
        return;
      }

      let isLoadedInterval = setInterval(() => {
        if (this.loadedSkills.indexOf(id) !== -1) {
          this.$nextTick().then(() => {
            let content = e.target
              .closest(".custom-accordion--item")
              .querySelector(".accordion-content");
            content.style.maxHeight = content.scrollHeight + "px";
          });

          clearInterval(isLoadedInterval);
        }
      }, 20);
    },
    getCustomValue(cat) {
      let el = this.applicantProfileSkillCategoryValues.find(
        e => e.skillCategory.id == cat
      );

      if (el) {
        return el.value;
      } else {
        this.applicantProfileSkillCategoryValues.push({
          profile: {
            id: this.profileId
          },
          skillCategory: {
            id: cat
          },
          value: ""
        });

        return this.getCustomValue(cat);
      }

      // return "";
    },
    updateCustomValue(id, val) {
      clearTimeout(this.customValueTimeouts[id]);

      let el = this.applicantProfileSkillCategoryValues.findIndex(
        e => e.skillCategory.id == id
      );
      if (el !== null) {
        this.applicantProfileSkillCategoryValues[el].value = val;
      } else {
        this.applicantProfileSkillCategoryValues.push({
          profile: {
            id: this.profileId
          },
          skillCategory: {
            id
          },
          value: val
        });
      }

      this.customValueTimeouts[id] = setTimeout(() => {
        this.$apollo.mutate({
          mutation: gql`
            mutation(
              $id: ID!
              $input: ApplicantProfileSkillCategoryValueInput!
            ) {
              saveApplicantProfileSkillCategory(
                applicantProfile: $id
                input: $input
              ) {
                profile {
                  id
                }
                skillCategory {
                  id
                }
                value
              }
            }
          `,
          variables: {
            id: this.profileId,
            input: {
              skillCategoryID: id,
              value: val,
              active: true
            }
          }
        });
      }, 600);
    }
  }
};
</script>

<style lang="scss" scoped>
.accordion-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.2s ease-out;
}
</style>
